import React from 'react';
import styled from "styled-components";
import {OutlineButton, PrimaryButton} from "../styled-components/buttons";
import {Paragraph} from "../styled-components/typography";
import {useTranslation} from "react-i18next";

interface ConfirmationDialogProps {
    onConfirmation: () => void;
    close: () => void;
    confirmationText: string;
    buttonConfirmationText: string;
}
const ConfirmationDialog = ({onConfirmation, close, confirmationText, buttonConfirmationText}: ConfirmationDialogProps) => {
    const {t} = useTranslation();

    return (
        <ConfirmationDialogContainer>
            <ConfirmationText>{confirmationText}</ConfirmationText>
            <ButtonsContainer>
                <CancelButton className={"btn btn-cancel"} onClick={close}>{t('cancel') as any}</CancelButton>
                <ConfirmationButton className={"btn btn-confirm"} onClick={onConfirmation}>{buttonConfirmationText}</ConfirmationButton>
            </ButtonsContainer>
        </ConfirmationDialogContainer>
    )
};

const ConfirmationDialogContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: white;
`;

const ConfirmationText = styled(Paragraph)`
  position: absolute;
  top: 90px;
  font-size: 22px;
  text-align: center;
`;

const ButtonsContainer = styled.div`
  position: absolute;
  top: 150px;
  display: flex;
  flex-direction: row;
`;

const ConfirmationButton = styled(PrimaryButton)``;
const CancelButton = styled(OutlineButton)`
  margin-right: 16px;
`;

export default ConfirmationDialog;
